// extracted by mini-css-extract-plugin
module.exports = {"tableDateInput":"style_tableDateInput__GUp1z","mantine-DateInput-input":"style_mantine-DateInput-input__ZSGvd"};